import { render, staticRenderFns } from "./OrganisationRow.vue?vue&type=template&id=df658ab2&scoped=true&"
import script from "./OrganisationRow.vue?vue&type=script&lang=js&"
export * from "./OrganisationRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=df658ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df658ab2",
  null
  
)

export default component.exports